import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ContactForm from './components/contactForm';
import ContactList from './components/contactList';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Button,
  Input,
  UncontrolledDropdown,
  Nav,
  NavItem,
  TabContent,
  NavLink,
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { aPI_Contacts } from '../../../../constants/APIs';
import Pagination from '../../../../containers/pages/Pagination';
import { NavLink as RouterNavLink } from 'react-router-dom';
import classnames from 'classnames';
import no_profile from '../../../../assets/profile_pic.png';
import IntlMessages from '../../../../helpers/IntlMessages';
import SendMessagePanel from '../Guest Messaging/reservation/components/SendMessagingManually/SendMessagePanel';
import { getTagsFromContacts } from './utils/contactTags';
const MEMBERS_TAB = 'members';
const VISITORS_TAB = 'visitors';
const MEMBER_CHANNEL = 'Compendium';
const styleCss = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
        top:auto !important;
        bottom: 0 !important;
      }
      .nav-tabs .nav-link {
        border: none;
      }
      .nav-tabs .nav-link.active,
      .nav-tabs .nav-link:hover {
        background-color: transparent;
      }`;
 
const getContact = (props) => {
  if (props?.original?.name && props?.original.name !== null)
    return (
      <p>
        <i className={`iconsminds-user`}></i> <b>{props?.original.name}</b>
      </p>
    );
  else if (props?.original?.email && props?.original.email !== null)
    return (
      <p>
        <i className={`iconsminds-at-sign`}></i> <b>{props?.original.email}</b>
      </p>
    );
  else if (props?.original?.phone && props?.original.phone !== null)
    return (
      <p>
        <i className={`simple-icon-phone`}></i> <b>{props?.original.phone}</b>
      </p>
    );
}; 
const contactTableColumns = [
  {
    Header: (
      <p>
        <i className="simple-icon-people pr-1"></i> Contact
      </p>
    ),
    accessor: 'name',
    Cell: (props) => <p className="ml-3">{getContact(props)}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar pr-1`}></i> First Activity
      </p>
    ),
    accessor: 'firstActivityDate',
    Cell: (props) => <p className="ml-4">{props?.original?.firstActivity}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-calendar pr-1`}></i> Recent Activity
      </p>
    ),
    accessor: 'lastActivityDate',
    Cell: (props) => (
      <p className="ml-4">
        {props?.original?.lastActivity === 'Unknown'
          ? props?.original?.firstActivity
          : props?.original?.lastActivity}
      </p>
    ),
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-settings pr-1`}></i> Last Channel
      </p>
    ),
    accessor: 'lastChannel',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: (
      <p>
        {' '}
        <i className="iconsminds-yes pr-1"></i>
        <IntlMessages id="dashboards.marketingconsent" />
      </p>
    ),
    accessor: 'consent',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
  {
    Header: '',
    Cell: (props) => (
      <RouterNavLink
        to={`/app/pages/contact-details/${props?.original?.contactId}?tab=${VISITORS_TAB}`}
      >
        <Button outline size="xs" color="primary" className="ml-4">
          <i className="simple-icon-action-redo"></i>
          {'  '}
          Open Contact
        </Button>
      </RouterNavLink>
    ),
  },
];
 
const contactCompendiumTableColumns = [
  {
    Header: (
      <p>
        <i className={`iconsminds-user`}></i> Name
      </p>
    ),
    accessor: 'name',
    Cell: (props) => {
      const baseImage = props?.original.profile;
      const hasImage =
        baseImage !== undefined &&
        baseImage !== null &&
        baseImage.trim() !== '';
 
      return (
        <div className="d-flex align-items-center">
          <img
            src={hasImage ? `data:image/jpeg;base64,${baseImage}` : no_profile}
            width="15"
            height="15"
            className="ml-4"
            alt=""
          />
          <p className="ml-2">
            <b>{props?.original.name}</b>
          </p>
        </div>
      );
    },
  },
  {
    Header: (
      <p>
        <i className={`iconsminds-at-sign`}></i> Email
      </p>
    ),
    accessor: 'email',
    Cell: (props) => <p className="ml-4">{props?.original.email}</p>,
  },
  {
    Header: (
      <p>
        <i className={`simple-icon-phone`}></i> Phone Number
      </p>
    ),
    accessor: 'phone',
    Cell: (props) => <p className="ml-4">{props?.original.phone}</p>,
  },
  {
    Header: (
      <p>
        <i className="iconsminds-id-card"></i> Membership Id
      </p>
    ),
    accessor: 'membershipId',
    Cell: (props) => (
      <p className="ml-4">{props?.original?.membershipId || ''}</p>
    ),
  },
  {
    Header: '',
    Cell: (props) => (
      <RouterNavLink
        to={`/app/pages/contact-details/${props?.original?.contactId}?tab=${MEMBERS_TAB}`}
      >
        <Button outline size="xs" color="primary" className="ml-4">
          <i className="simple-icon-action-redo"></i>
          {'  '}
          Open Contact
        </Button>
      </RouterNavLink>
    ),
  },
];
 
function Index({ propertyId }) {
  const [channel, setChannel] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get('tab');
    if (tab === MEMBERS_TAB || tab === MEMBER_CHANNEL) return MEMBER_CHANNEL;
    if (tab === VISITORS_TAB) return '';
    return window.location.href.includes('/app/pages/members')
      ? MEMBER_CHANNEL
      : '';
  });
  const [addContact, setEditContact] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const [pageSizes, setpageSizes] = useState([25, 50, 75, 100]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(25);
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [contact, setContact] = useState();
  const [tags, setTags] = useState([]);
  const [showSendMessage, setShowSendMessage] = useState(false);
  const isMembersView = channel === 'Compendium';
  const [marketingConsent, setMarketingConsent] = useState('');
  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };
 
  const toggle = () => setEditContact(!addContact);
 
  const onChangePage = (page) => setcurrentPage(page);
 
  const handleTabChange = (nextChannel) => {
    const tab = nextChannel === MEMBER_CHANNEL ? MEMBERS_TAB : VISITORS_TAB;
    setChannel(nextChannel);
    window.history.replaceState(null, '', `/app/pages/members?tab=${tab}`);
  };
 
  useEffect(() => {
    handleContactLoad();
  }, [propertyId, currentPage, SelectedPageSize, search, channel]);
 
  const handleContactLoad = () => {
    AxiosAPI({
      method: 'get',
      url: `${aPI_Contacts}?groupId=${getGroupID()}&propertyId=${propertyId}&search=${search}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}&type=${channel}`,
    }).then((res) => {
      const contacts = res.data?.contacts || [];
      setTotalItems(res.data.totalItems);
      setTotalPages(res.data.totalPages);
      setContactsList(contacts);
      setTags(getTagsFromContacts(contacts));
    });
  };
 
  const onSearchKey = (e) => {
    //if (e.key === "Enter") {
    setcurrentPage(1);
    setSearch(e.target.value.toLowerCase());
    // LoadBmbData();
    //}
  };
 
  const handleSave = (body) => {
    if (aPI_Contacts.email !== '') {
      AxiosAPI({
        method: 'POST',
        url: `${aPI_Contacts}`,
        data: body,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        toggle();
        handleContactLoad();
      });
    } else toggle();
  };
 
  return (
    <Fragment>
      <Row className="mb-3">
        <Colxx xxs="12" className="mb-1">
          <Nav tabs className="card-header-tabs separator-tabs mb-1 ml-0 mr-0">
          <style>{styleCss}</style>
            <NavItem>
              <NavLink
                className={classnames({
                  active: channel === '',
                  'nav-link': true,
                })}
                onClick={() => {
                  handleTabChange('');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${channel === '' ? 'var(--theme-color-1)' : '#8f8f8f'
                      }`,
                  }}
                >
                  Visitors
                </span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({
                  active: channel === MEMBER_CHANNEL,
                  'nav-link': true,
                })}
                onClick={() => {
                  handleTabChange(MEMBER_CHANNEL);
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${channel === 'Compendium'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                      }`,
                  }}
                >
                  Members
                </span>
              </NavLink>
            </NavItem>
          </Nav>
        </Colxx>
        <Colxx xxs="12" className="my-2">
          <div className="float-md-left mr-2">
            <div
              className="search-sm d-inline-block float-md-left mr-3 mb-1 align-top"
              style={{ width: '100%' }}
            >
              <Input
                type="text"
                name="keyword"
                id="search"
                placeholder="Search"
                onChange={(e) => onSearchKey(e)}
                style={{ width: '100%' }}
              />
            </div>
          </div>
          <div className="float-md-left">
            <Button color="primary" outline size="xs" onClick={toggle}>
              + Contact
            </Button>
          </div>
          {isMembersView && (
            <div className="float-md-left ml-2">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={() => setShowSendMessage(true)}
              >
                Send Message
              </Button>
            </div>
          )}
          {/* <div className="float-md-left ml-3">
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-primary" size="xs">
                {channel === '' ? 'Website' : 'Compendium'}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem key={'Website'} onClick={() => setChannel('')}>
                  Website
                </DropdownItem>
                <DropdownItem
                  key={'Compendium'}
                  onClick={() => setChannel('Compendium')}
                >
                  Compendium
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div> */}
          <div className="float-md-right">
            <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
            <UncontrolledDropdown className="d-inline-block">
              <DropdownToggle caret color="outline-dark" size="xs">
                {SelectedPageSize}
              </DropdownToggle>
              <DropdownMenu right>
                {pageSizes.map((size, index) => {
                  return (
                    <DropdownItem
                      key={index}
                      onClick={() => changePageSize(size)}
                    >
                      {size}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Colxx>
        <Colxx xxs="12" className="my-1">
          <TabContent activeTab={channel}>
            <Colxx xxs="12" className="mb-3 px-0">
              {contactList.length > 0 && (
                <ContactList
                  handleContactLoad={handleContactLoad}
                  propertyId={propertyId}
                  columns={
                    channel !== ''
                      ? contactCompendiumTableColumns
                      : contactTableColumns
                  }
                  data={contactList}
                  taglist={tags}
                  totalPage={TotalPages}
                  pageSize={SelectedPageSize}
                  currentPage={currentPage}
                  onChangePage={onChangePage}
                ></ContactList>
              )}
              <Pagination
                currentPage={currentPage}
                totalPage={TotalPages}
                onChangePage={(i) => onChangePage(i)}
              />
            </Colxx>
          </TabContent>
        </Colxx>
      </Row>
      {addContact && (
        <ContactForm
          toggle={toggle}
          visible={addContact}
          propertyId={propertyId}
          taglist={tags}
          handleSubmit={handleSave}
        ></ContactForm>
      )}
      {showSendMessage && (
        <SendMessagePanel
          activeTab="sms"
          onClose={() => setShowSendMessage(false)}
          propertyId={propertyId}
          source="MembersBulk"
          showStatusFilter={false}
          showEligibleCount={true}
          marketingConsent={marketingConsent}
          setMarketingConsent={setMarketingConsent}
          eligibleCount={TotalItems}
          eligibleCountLabel="Eligible Members"
          allowedTabs={['sms', 'whatsapp']}
          disableSubmit={true}
        />
      )}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};
export default injectIntl(connect(mapStateToProps, {})(Index)); 
 